import { State } from '#/unified-rfqs/ui/rfq-builder/store';
import { getActiveProductsByVenue } from '#/products/domain';
import { venueSupportsCustomStrategy } from '#/unified-rfqs/entities/products/venue';

export default function productView(
  selectedProductCode: State['productCode'],
  selectedVenue: State['venue'],
  auction: State['auction'],
) {
  const products = getActiveProductsByVenue(selectedVenue, auction);
  const ALL_OPTION = { value: null, label: 'All' };

  const productOptions = products.map((p) => ({
    value: p.code,
    label: p.longName,
  }));

  const options = venueSupportsCustomStrategy(selectedVenue)
    ? [...productOptions, ALL_OPTION]
    : productOptions;

  const selectedOption = options.find(
    (option) => option.value === selectedProductCode,
  );

  if (selectedOption === undefined)
    throw new TypeError(
      `Product with code '${selectedProductCode}' doesn't exist.`,
    );

  return { options, selectedOption };
}
